import { FC, ReactElement } from 'react';

import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';

export const DangerBanner: FC<{
  title: string;
  text: string | ReactElement;
  button?: { text: string; onClick?: () => void };
  onClick?: () => void;
}> = ({ title, text, button, onClick }) => {
  return (
    <div
      className="relative"
      style={{
        background: 'rgb(255, 148, 148)',
        color: 'rgb(162, 6, 6)',
        // background: 'rgba(226, 32, 95, 0.2)',
        // color: 'rgb(226, 32, 110)',
        borderRadius: 8,
        overflow: 'hidden',
      }}
      onClick={onClick}
    >
      <div className="d-flex gap-2 py-2 px-2">
        <div>
          <FontAwesomeIcon name="info-circle" />
        </div>
        <div>
          <div className="d-flex align-items-center gap-2">
            <strong>{title}</strong>
          </div>
          <div style={{ opacity: 0.85, lineHeight: 1.3, fontSize: '.8rem' }}>
            {typeof text === 'string' ? <span>{text}</span> : <>{text}</>}
          </div>
          {button && (
            <div className="mt-2">
              <div
                className="px-3 py-1"
                style={{
                  display: 'inline-block',
                  opacity: 0.85,
                  fontSize: '.7rem',
                  border: '1px solid rgb(162, 6, 6)',
                  borderRadius: 4,
                }}
                onClick={button.onClick}
              >
                {button.text}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
